import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="7" fill="white"/>
    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 10.5996L9.40039 8L8 9.40039L10.5996 12L8 14.5996L9.40039 16L12 13.4004L14.5996 16L16 14.5996L13.4004 12L16 9.40039L14.5996 8L12 10.5996Z" fill="#CC0000"/>
  </svg>
);

export default SVGComponent;